export const StatsCard = ({
  title,
  value,
  bgColor = "bg-gray-500",
}: {
  title: string;
  value: string | number;
  bgColor?: string;
}) => {
  return <div className={`${bgColor} h-full w-1/3 rounded-lg`}>

    <div className="flex flex-col justify-center h-full ml-5 text-black">
      <h2 className="text-4xl font-bold">{value}</h2>
      <p className="text-lg font-medium">{title}</p>
    </div>


  </div>;
};
